<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="headersApprovals"
          :items="data.approvals"
          :items-per-page="20"
          no-data-text="No hay registro"
        >
          <template v-slot:top v-if="role == 'EMPLOYEE' && approved">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-btn color="success" dark class="mb-2" @click="approval">
                <v-icon left dark> mdi-check </v-icon>
                Aprobar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.name`]="item">
            {{ item.item.supervisor.employee.user.full_name }}
          </template>
          <template v-slot:[`item.created_at`]="item">
            {{ item.item.created_at | dateFormat }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- approval dialog -->
    <v-dialog v-model="dialogApproval" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea aprobar este informe?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-4" @click="approvedConfirmed" small>
            Confirmar
          </v-btn>

          <v-btn
            color="error"
            text
            class="mr-4"
            @click="dialogApproval = false"
            small
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */
export default {
  name: "Approvals",
  props: {
    data: {
      required: true,
    },
  },
  filters: {
    dateFormat(date) {
      date = new Date(date);
      return date.toLocaleString("en-US");
    },
  },
  data: () => ({
    dialogApproval: false,
    headersApprovals: [
      {
        text: "Supervisor",
        value: "name",
        sortable: true,
      },
      {
        text: "Fecha",
        value: "created_at",
        filterable: false,
        sortable: false,
      },
    ],
  }),
  computed: {
    approved() {
      if (this.data) {
        var supervisor = this.data.contract.supervisors.find(
          (obj) => obj.employee_id == this.$store.state.user.user.employee.id
        );

        if (!supervisor) {
          return false;
        }

        if (this.data.approvals.length) {
          var approval = this.data.approvals.find(
            (obj) => obj.supervisor_id == supervisor.id
          );

          return approval ? approval.length == 0 : true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
  },
  methods: {
    approval() {
      this.dialogApproval = true;
    },
    approvedConfirmed() {
      this.$store.dispatch("createApproval", {
        supervisor_id: this.data.contract.supervisors.find(
          (obj) => obj.employee_id == this.$store.state.user.user.employee.id
        ).id,
        report_id: this.data.id,
      });
      this.dialogApproval = false;
    },
  },
};
</script>
